import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import data from './data.json'

const Post = () => {
  const { postId } = useParams();
  const post = data.posts.find(post => postId === post.id);

  if (!post) {
    return <Navigate to='/' />
  }

  return (
    <div>
      <p className='mb-3'>{post.date}</p>
      <h2 className='mb-3'>{post.title}</h2>
      {post.content_images_urls.map((url, index) => (
        <div key={`pciu-${index}`} className='post-pic-container'>
          <img className='post-pic' src={url} alt='post-pic' />
        </div>
      ))}
      <p className='content mb-5'>{post.content}</p>
    </div>
  );
};

export default Post;
